import { GET_STORES } from "../action-types"

const initialState = { stores: [] }
const appReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_STORES:
      return { ...state, stores: payload }
    default:
      return state
  }
}
export default appReducer